// This refers to the value of the ID of the 'Personal ID' requirement
export const PERSONAL_IDENTIFICATION_REQUIREMENT_ID = "5b932fcb38aeaa0014c3688f";
